
const Loading=()=>{

    return(
        <div className='absolute top-0 bg-black bg-opacity-40 h-full w-full z-10'></div>
    )
}

export default Loading